"use strict";

exports.__esModule = true;
exports.RendererContext = void 0;

var _react = require("react");

var _blocks = require("../blocks");

/**
 * @typedef {object} RendererContextValue
 * @property {import("../../types/types").DocumentJson} document
 * @property {any[]} tools
 * @property {{name: string, key: string}} language
 */

/** @type {RendererContextValue} */
var DEFAULT_VALUE = {
  document: _blocks.DOCUMENT,
  tools: [],
  language: {
    name: "Français",
    key: "fr"
  }
};
var RendererContext = /*#__PURE__*/(0, _react.createContext)(DEFAULT_VALUE);
exports.RendererContext = RendererContext;